import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const TourContext = createContext(null);

const TOUR_REGISTRO_KEY = 'palletcloud_tour_registro_visto';

export const pasosRegistro = [
  {
    id: 'bienvenida',
    titulo: '¡Bienvenido a PalletCloud!',
    icono: 'wave',
    descripcion: 'Te mostraremos cómo crear tu cuenta con correo electrónico o con Google y Facebook.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'nav-menu',
    titulo: 'Paso 1 — Menú de navegación',
    icono: null,
    descripcion: 'Abre el menú de navegación para encontrar las opciones de acceso a tu cuenta.',
    selector: '[data-tour="nav-menu"]',
    accion: 'irAInicio',
    posicion: 'bottom',
  },
  {
    id: 'btn-registrate',
    titulo: 'Paso 2 — Regístrate',
    icono: null,
    descripcion: 'Selecciona “Regístrate”. Se abrirá el acceso unificado para iniciar sesión o crear una cuenta.',
    selector: '[data-tour="btn-registrate"]',
    accion: 'abrirMenu',
    posicion: 'bottom',
  },
  {
    id: 'metodo-registro',
    titulo: 'Paso 3 — Elige cómo continuar',
    icono: 'user',
    descripcion: 'Puedes registrarte con tu correo electrónico o usar directamente tu cuenta de Google o Facebook.',
    selector: '[data-tour="auth-inicio"]',
    accion: 'abrirModal',
    posicion: 'center',
  },
  {
    id: 'registro-correo',
    titulo: 'Paso 4 — Registro con correo',
    icono: 'email',
    descripcion: 'Escribe un correo válido. Si todavía no existe una cuenta asociada, PalletCloud comenzará automáticamente el registro.',
    selector: '[data-tour="input-correo"]',
    accion: null,
    posicion: 'bottom',
  },
  {
    id: 'registro-social',
    titulo: 'Paso 5 — Google o Facebook',
    icono: 'social',
    descripcion: 'También puedes continuar con Google o Facebook. Serás redirigido de forma segura para autorizar tu cuenta.',
    selector: '[data-tour="btn-sociales"]',
    accion: null,
    posicion: 'top',
  },
  {
    id: 'btn-continuar',
    titulo: 'Paso 6 — Continuar',
    icono: null,
    descripcion: 'Al continuar, una cuenta nueva recibirá un código de verificación. Si el correo ya está registrado, podrás ingresar con tu contraseña.',
    selector: '[data-tour="btn-continuar"]',
    accion: null,
    posicion: 'top',
  },
  {
    id: 'verificacion',
    titulo: 'Paso 7 — Verifica tu cuenta',
    icono: 'lock',
    descripcion: 'Revisa tu correo, captura el código de seis dígitos y presiona “Confirmar”. Si no llega, podrás reenviarlo después del contador.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'perfil',
    titulo: 'Paso 8 — Completa tu perfil',
    icono: 'user',
    descripcion: 'Captura tu teléfono, nombre, apellidos y fecha de nacimiento. El correo verificado aparecerá automáticamente.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'seguridad',
    titulo: 'Paso 9 — Contraseña segura',
    icono: 'lock',
    descripcion: 'Crea y confirma una contraseña de al menos ocho caracteres, con mayúscula, minúscula, número y carácter especial.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'consentimientos',
    titulo: 'Paso 10 — Documentos legales',
    icono: 'document',
    descripcion: 'Acepta los Términos y Condiciones, la Política de Privacidad y el Consentimiento de Datos Personales para finalizar.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'listo',
    titulo: '¡Cuenta creada!',
    icono: 'check',
    descripcion: 'Al guardar tus datos, tu sesión quedará iniciada y regresarás a la página donde comenzaste.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
];

export const pasosAlta = [
  {
    id: 'bienvenida-alta',
    titulo: 'Registrar Empresa o Persona Física',
    icono: 'building',
    descripcion: 'Te guiaremos paso a paso para dar de alta tu empresa o persona física. ¡Es sencillo y solo toma unos minutos!',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'btn-menu',
    titulo: 'Paso 1 — Abre el menú',
    icono: null,
    descripcion: 'Toca el ícono de menú (arriba a la derecha) para ver las opciones disponibles.',
    selector: '[data-tour="nav-menu"]',
    accion: 'irAInicio',
    posicion: 'bottom',
  },
  {
    id: 'btn-renta',
    titulo: 'Paso 2 — Renta tu almacén',
    icono: null,
    descripcion: 'Dentro del menú, toca "Renta tu almacén". Esto te llevará al panel de anfitrión.',
    selector: '[data-tour="btn-renta"]',
    accion: 'abrirMenu',
    posicion: 'bottom',
  },
  {
    id: 'nav-gestion',
    titulo: 'Paso 3 — Gestión',
    icono: null,
    descripcion: 'En el menú superior del panel, toca "Gestión" para administrar tus empresas y almacenes.',
    selector: '[data-tour="nav-gestion"]',
    accion: 'abrirMenuHost',
    posicion: 'bottom',
  },
  {
    id: 'btn-agregar-empresa',
    titulo: 'Paso 4 — Agregar empresa',
    icono: null,
    descripcion: 'Aquí verás tus empresas registradas. Toca "+ Agregar Empresa/Persona" para crear una nueva.',
    selector: '[data-tour="btn-agregar-empresa"]',
    accion: 'irAGestion',
    posicion: 'bottom',
  },
  {
    id: 'form-info',
    titulo: 'Paso 5 — Información de la empresa',
    icono: 'user',
    descripcion: 'Elige el tipo de persona (Física o Moral), llena el nombre o razón social, RFC y CLABE interbancaria. Cuando termines, haz clic en "Guardar".',
    selector: null,
    accion: 'irAPersonaNueva',
    posicion: 'center',
  },
  {
    id: 'tab-documentos',
    titulo: 'Paso 6 — Documentos',
    icono: 'email',
    descripcion: 'Una vez guardada tu información, ve a la pestaña "Documentos" y sube tu identificación oficial y constancia de situación fiscal.',
    selector: '[data-tour="tab-documentos"]',
    accion: null,
    posicion: 'bottom',
  },
  {
    id: 'listo-alta',
    titulo: '¡Empresa registrada!',
    icono: 'check',
    descripcion: 'Revisaremos tus documentos y, una vez aprobados, tu empresa quedará activa para que puedas publicar tus almacenes.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
];

export const pasosAlmacen = [
  {
    id: 'bienvenida-almacen',
    titulo: 'Dar de alta un almacén',
    icono: 'warehouse',
    descripcion: 'Te guiaremos sección por sección para registrar tu almacén. Mientras más completa sea la información, más visibilidad tendrá tu espacio en las búsquedas.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'menu-almacen',
    titulo: 'Paso 1 — Abre el menú',
    icono: null,
    descripcion: 'Toca el ícono de menú (arriba a la derecha) para ver las opciones disponibles.',
    selector: '[data-tour="nav-menu"]',
    accion: 'irAInicio',
    posicion: 'bottom',
  },
  {
    id: 'renta-almacen',
    titulo: 'Paso 2 — Renta tu almacén',
    icono: null,
    descripcion: 'Dentro del menú, toca "Renta tu almacén" para acceder al panel de anfitrión.',
    selector: '[data-tour="btn-renta"]',
    accion: 'abrirMenu',
    posicion: 'bottom',
  },
  {
    id: 'gestion-almacen',
    titulo: 'Paso 3 — Gestión',
    icono: null,
    descripcion: 'En el menú superior del panel anfitrión, toca "Gestión" para administrar tus espacios.',
    selector: '[data-tour="nav-gestion"]',
    accion: 'abrirMenuHost',
    posicion: 'bottom',
  },
  {
    id: 'nav-almacenes',
    titulo: 'Paso 4 — Sección Almacenes',
    icono: null,
    descripcion: 'En el panel lateral izquierdo, toca “Almacenes” para ver y gestionar todos tus espacios registrados.',
    selector: '[data-tour="nav-almacenes"]',
    accion: 'abrirMenuGestion',
    posicion: 'bottom',
  },
  {
    id: 'btn-agregar-almacen',
    titulo: 'Paso 5 — Agregar almacén',
    icono: null,
    descripcion: 'Toca "+ Agregar Almacén" para comenzar a registrar un nuevo espacio de almacenaje.',
    selector: '[data-tour="btn-agregar-almacen"]',
    accion: 'irAGestionAlmacenes',
    posicion: 'bottom',
  },
  {
    id: 'info-almacen',
    titulo: 'Paso 6 — Información general',
    icono: 'user',
    descripcion: 'Ingresa el nombre del almacén y asígnalo a tu empresa. Luego llena el área total, área disponible, pallet positions, rampas de carga y andenes. Estos datos son los primeros que ven los clientes.',
    selector: null,
    accion: 'irAAlmacenNuevo',
    posicion: 'center',
  },
  {
    id: 'tab-tipo',
    titulo: 'Paso 7 — Tipo de almacenaje',
    icono: null,
    descripcion: 'Selecciona todos los tipos de almacenaje que ofrece tu espacio: refrigerado, en rack, a granel, cross-docking, entre otros. Puedes marcar varios — más opciones atraen más clientes.',
    selector: '[data-tour="tab-tipo"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'tab-domicilio',
    titulo: 'Paso 8 — Domicilio y mapa',
    icono: null,
    descripcion: 'Ingresa la dirección exacta y ajusta el pin en el mapa. La ubicación precisa es crucial — los clientes buscan almacenes por zona geográfica y distancia a su operación.',
    selector: '[data-tour="tab-domicilio"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'tab-horarios',
    titulo: 'Paso 9 — Horarios de atención',
    icono: null,
    descripcion: 'Define los días y horas en que tu almacén puede recibir mercancía. Puedes configurar horarios distintos para cada día de la semana e indicar si aceptas operaciones en sábado o domingo.',
    selector: '[data-tour="tab-horarios"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'tab-vehiculos',
    titulo: 'Paso 10 — Tipos de vehículos',
    icono: null,
    descripcion: 'Indica qué tipos de transporte pueden acceder a tu almacén: camionetas, rabón, torton, full, etc. Esta información permite a los clientes saber si su logística es compatible con tu espacio.',
    selector: '[data-tour="tab-vehiculos"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'tab-servicios',
    titulo: 'Paso 11 — Servicios del almacén',
    icono: null,
    descripcion: 'Marca todos los servicios con los que cuenta tu almacén: cámaras de seguridad, montacargas, pick & pack, maniobras de carga y descarga, entre otros. Más servicios = mayor valor percibido.',
    selector: '[data-tour="tab-servicios"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'tab-seguros',
    titulo: 'Paso 12 — Seguros',
    icono: 'lock',
    descripcion: 'Sube los certificados o pólizas de seguro de tu almacén. Esto genera confianza en los clientes y puede ser requisito obligatorio para rentas de mayor volumen o empresas grandes.',
    selector: '[data-tour="tab-seguros"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'tab-docs-almacen',
    titulo: 'Paso 13 — Documentos',
    icono: 'email',
    descripcion: 'Sube los documentos de tu almacén: comprobante de domicilio, plano de distribución de espacios, croquis de acceso y TIF si aplica. Son necesarios para la revisión y aprobación del espacio.',
    selector: '[data-tour="tab-docs-almacen"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'tab-fotos-almacen',
    titulo: 'Paso 14 — Fotografías',
    icono: null,
    descripcion: 'Agrega fotos del interior, exterior, andenes, área de oficinas y zonas de servicio. Los almacenes con buenas fotografías reciben significativamente más solicitudes de renta.',
    selector: '[data-tour="tab-fotos-almacen"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'btn-guardar-almacen',
    titulo: 'Paso 15 — Guardar',
    icono: null,
    descripcion: 'Usa el botón "Guardar" (visible siempre en la parte superior) después de cada sección. Puedes guardarlo en cualquier momento y retomar la edición más adelante.',
    selector: '[data-tour="btn-guardar-almacen"]',
    accion: null,
    posicion: 'bottom',
  },
  {
    id: 'listo-almacen',
    titulo: '¡Almacén registrado!',
    icono: 'check',
    descripcion: 'Revisaremos tu información y documentos. Una vez aprobado, tu almacén aparecerá en las búsquedas y comenzarás a recibir solicitudes de reservación.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
];

export const pasosPublicacion = [
  {
    id: 'bienvenida-publicacion',
    titulo: '¡Crea tu primera publicación!',
    icono: 'post',
    descripcion: 'Una publicación es la oferta que verán los clientes en la plataforma. Defines el precio, los periodos de renta, las dimensiones del espacio y las condiciones de cancelación. ¡Comencemos!',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'menu-publicacion',
    titulo: 'Paso 1 — Abre el menú',
    icono: null,
    descripcion: 'Toca el ícono de menú (☰) para desplegar las opciones de navegación.',
    selector: '[data-tour="nav-menu"]',
    accion: 'irAInicio',
    posicion: 'bottom',
  },
  {
    id: 'renta-publicacion',
    titulo: 'Paso 2 — Renta tu almacén',
    icono: null,
    descripcion: 'Desde el menú, selecciona "Renta tu almacén" para entrar al panel de anfitrión donde gestionas tus espacios y publicaciones.',
    selector: '[data-tour="btn-renta"]',
    accion: 'abrirMenu',
    posicion: 'bottom',
  },
  {
    id: 'gestion-publicacion',
    titulo: 'Paso 3 — Panel de Gestión',
    icono: null,
    descripcion: 'En el panel del anfitrión, accede a "Gestión" para administrar tus empresas, almacenes y publicaciones.',
    selector: '[data-tour="nav-gestion"]',
    accion: 'abrirMenuHost',
    posicion: 'bottom',
  },
  {
    id: 'nav-publicaciones',
    titulo: 'Paso 4 — Sección Publicaciones',
    icono: null,
    descripcion: 'En el menú lateral de Gestión, toca “Publicaciones” para ver y administrar todas las publicaciones de tus almacenes.',
    selector: '[data-tour="nav-publicaciones"]',
    accion: 'abrirMenuGestion',
    posicion: 'right',
  },
  {
    id: 'lista-almacenes-pub',
    titulo: 'Paso 5 — Tus almacenes',
    icono: null,
    descripcion: 'Verás la lista de tus almacenes aprobados. Haz clic en cualquiera para acceder a sus publicaciones y crear una nueva.',
    selector: null,
    accion: 'irAGestionPublicaciones',
    posicion: 'center',
  },
  {
    id: 'btn-agregar-pub',
    titulo: 'Paso 6 — Agregar Publicación',
    icono: null,
    descripcion: 'Este botón abre el selector de almacenes para crear una nueva publicación. Puedes tener varias publicaciones por almacén con distintos precios o condiciones. Presiona "Siguiente" para continuar.',
    selector: '[data-tour="btn-agregar-publicacion"]',
    accion: null,
    posicion: 'bottom',
  },
  {
    id: 'seleccionar-almacen-pub',
    titulo: 'Paso 7 — Selecciona un almacén',
    icono: null,
    descripcion: 'Aparece la lista de tus almacenes registrados. Haz clic en el almacén que deseas publicar — eso te llevará directo al formulario de creación de publicación.',
    selector: '[data-tour="btn-agregar-publicacion"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'click-almacen-pub',
    titulo: 'Paso 8 — Entrando al formulario',
    icono: null,
    descripcion: 'Seleccionamos tu primer almacén como ejemplo. Puedes crear publicaciones para cualquiera de tus almacenes aprobados desde esta pantalla.',
    selector: '[data-tour="almacen-item-selector"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'tab-info-pub',
    titulo: 'Paso 7 — Tab Información',
    icono: null,
    descripcion: 'El formulario tiene tres secciones. La primera es Información: tipo de almacenaje, modo de confirmación de reservas, título, dimensiones y capacidad de carga.',
    selector: '[data-tour="tab-info-pub"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'tipo-almacenaje-pub',
    titulo: 'Paso 8 — Tipo de almacenaje',
    icono: null,
    descripcion: 'Selecciona qué tipos de almacenaje ofrece este espacio: refrigerado, en rack, a granel, cross-docking, etc. Puedes elegir varios — más opciones aumentan la visibilidad de la publicación.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'confirmacion-pub',
    titulo: 'Paso 9 — Confirmación de reserva',
    icono: null,
    descripcion: '"Inmediata" confirma automáticamente al acreditarse el pago. "Consultar Host" te permite revisar y aprobar cada reserva antes de confirmarla al cliente. Elige según tu disponibilidad de atención.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'datos-pub',
    titulo: 'Paso 10 — Datos del espacio',
    icono: null,
    descripcion: 'Completa el título de la publicación, los espacios asignados y las dimensiones del rack o área (ancho × largo × alto en cm/ft) y la capacidad máxima de carga en kg/lb.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'tab-precios-pub',
    titulo: 'Paso 11 — Tab Precios',
    icono: null,
    descripcion: 'En la pestaña Precios configuras los costos de maniobra (Precio In/Out) y los periodos de renta disponibles con su precio, duración mínima, máxima y condición de crédito.',
    selector: '[data-tour="tab-precios-pub"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'precio-inout-pub',
    titulo: 'Paso 12 — Precio In / Out',
    icono: null,
    descripcion: '"Precio In" es el costo por recibir la mercancía al ingreso y "Precio Out" por entregarla al retiro. Son costos únicos por maniobra, independientes del periodo de renta.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'periodos-pub',
    titulo: 'Paso 13 — Periodos de renta',
    icono: null,
    descripcion: 'Activa los periodos que ofreces: Día, Semana, Mes o Año. Para cada uno define el precio base, el periodo mínimo y máximo de renta, y la condición de crédito (días de pago). La facturación es semanal para día/semana y mensual para mes/año.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'desglose-pub',
    titulo: 'Paso 14 — Desglose de ganancias',
    icono: null,
    descripcion: 'Al configurar los precios verás un desglose automático: monto bruto − comisión PalletCloud (5%) + IVA (16%). Así sabes exactamente cuánto recibirás por renta mensual antes de publicar.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'tab-cancelacion-pub',
    titulo: 'Paso 15 — Política de Cancelación',
    icono: 'lock',
    descripcion: 'Define tu política: Reembolso Total (el cliente cancela hasta 7 días antes = 100% devuelto), Reembolso Parcial (50% devuelto) o Sin Reembolso. Esta información es visible para el cliente antes de reservar.',
    selector: '[data-tour="tab-cancelacion-pub"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'btn-guardar-pub',
    titulo: 'Paso 16 — Guardar',
    icono: null,
    descripcion: 'Usa "Guardar" para almacenar todos los cambios en cualquier momento. La publicación no es visible para los clientes hasta que cambies su estado a "Publicada".',
    selector: '[data-tour="btn-guardar-pub"]',
    accion: null,
    posicion: 'bottom',
  },
  {
    id: 'btn-publicar-pub',
    titulo: 'Paso 17 — Publicar',
    icono: null,
    descripcion: 'Cuando la publicación esté lista, cambia su estado a "Publicada". A partir de ese momento aparecerá en los resultados de búsqueda y los clientes podrán solicitar reservaciones.',
    selector: '[data-tour="btn-publicar-pub"]',
    accion: null,
    posicion: 'bottom',
  },
  {
    id: 'listo-publicacion',
    titulo: '¡Publicación lista!',
    icono: 'check',
    descripcion: '¡Excelente! Tu oferta ya está visible en la plataforma. Recuerda mantener actualizados los espacios disponibles y responder rápido a las solicitudes para mejorar tu ranking.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
];

export const pasosReserva = [
  {
    id: 'bienvenida-reserva',
    titulo: '¡Reserva un almacén!',
    icono: 'calendar',
    descripcion: 'Te mostraremos paso a paso cómo encontrar y reservar un espacio de almacenaje. ¡Es muy sencillo!',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'buscador-lugar',
    titulo: 'Paso 1 — Buscador',
    icono: null,
    descripcion: 'En la barra superior escribe la ciudad, estado o municipio donde necesitas almacenar tu mercancía.',
    selector: '[data-tour="lbl-lugar"]',
    accion: 'irAInicio',
    posicion: 'bottom',
  },
  {
    id: 'buscador-fechas',
    titulo: 'Paso 2 — Fechas y espacios',
    icono: null,
    descripcion: 'Selecciona las fechas de inicio y fin, e indica cuántos espacios de rack necesitas. El buscador filtrará automáticamente los almacenes disponibles en ese periodo.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'btn-buscar',
    titulo: 'Paso 3 — Buscar',
    icono: null,
    descripcion: 'Pulsa el botón Buscar para ver la lista de almacenes disponibles en esa zona con sus precios y disponibilidad.',
    selector: '[data-tour="btn-buscar"]',
    accion: null,
    posicion: 'bottom',
  },
  {
    id: 'resultados-reserva',
    titulo: 'Paso 4 — Resultados de búsqueda',
    icono: null,
    descripcion: 'Cada tarjeta que ves es un almacén publicado. Muestra foto, nombre, ubicación y precio mensual desde el más económico. El rayo indica que tiene Reserva Inmediata.',
    selector: '[data-tour="almacen-card"]',
    accion: null,
    posicion: 'bottom',
  },
  {
    id: 'click-almacen',
    titulo: 'Paso 5 — Ver detalle del almacén',
    icono: null,
    descripcion: 'Haz clic en la tarjeta para entrar a la página de detalle donde podrás ver toda la información y configurar tu reserva.',
    selector: '[data-tour="almacen-card"]',
    accion: null,
    autoClick: true,
    posicion: 'bottom',
  },
  {
    id: 'detalle-almacen',
    titulo: 'Paso 6 — Panel de reserva',
    icono: null,
    descripcion: 'Aquí está el panel de configuración de tu reserva. Elige el periodo, los espacios y las fechas antes de solicitar.',
    selector: '[data-tour="panel-reservar"]',
    accion: null,
    posicion: 'left',
  },
  {
    id: 'sel-periodo-reserva',
    titulo: 'Paso 7 — Periodo de renta',
    icono: null,
    descripcion: 'Elige el periodo que mejor se adapte a tu necesidad: Día, Semana, Mes o Año. Cada opción muestra el precio unitario. Al seleccionarlo los campos de duración se actualizan automáticamente.',
    selector: '[data-tour="sel-periodo"]',
    accion: null,
    posicion: 'left',
  },
  {
    id: 'input-espacios-reserva',
    titulo: 'Paso 8 — Cantidad de espacios',
    icono: null,
    descripcion: 'Indica cuántos espacios de rack necesitas. Revisa que el almacén tenga suficientes espacios disponibles para tu solicitud.',
    selector: '[data-tour="input-espacios-reservar"]',
    accion: null,
    posicion: 'left',
  },
  {
    id: 'input-duracion-reserva',
    titulo: 'Paso 9 — Duración',
    icono: null,
    descripcion: 'Ingresa el número de días, semanas, meses o años que necesitas el espacio. Las fechas de entrada y salida se calcularán automáticamente, o puedes elegirlas desde el calendario.',
    selector: '[data-tour="input-duracion-reservar"]',
    accion: null,
    posicion: 'left',
  },
  {
    id: 'btn-reservar-reserva',
    titulo: 'Paso 10 — Botón Reservar',
    icono: null,
    descripcion: 'Cuando hayas configurado el periodo, espacios y fechas, pulsa el botón "Reservar". Serás redirigido al formulario de confirmación donde completarás tus datos y método de pago.',
    selector: '[data-tour="btn-reservar-almacen"]',
    accion: null,
    posicion: 'top',
  },
  {
    id: 'click-reservar',
    titulo: 'Paso 11 — Ir al formulario',
    icono: null,
    descripcion: 'El tour pulsará "Reservar" por ti para llevarte al formulario de confirmación.',
    selector: '[data-tour="btn-reservar-almacen"]',
    accion: null,
    autoClick: true,
    posicion: 'top',
  },
  {
    id: 'contacto-reserva',
    titulo: 'Paso 12 — Datos de contacto',
    icono: 'user',
    descripcion: 'Ingresa tu número de teléfono y selecciona el RFC (perfil fiscal) con el que se emitirá la factura. Si aún no tienes un perfil registrado, puedes crearlo desde ese mismo formulario.',
    selector: '[data-tour="datos-pago-contacto"]',
    accion: null,
    posicion: 'right',
  },
  {
    id: 'input-telefono-reserva',
    titulo: 'Paso 13 — Teléfono',
    icono: null,
    descripcion: 'El Host necesita tu teléfono para coordinar el acceso al almacén y resolver cualquier duda sobre tu reserva.',
    selector: '[data-tour="input-telefono"]',
    accion: null,
    posicion: 'right',
  },
  {
    id: 'select-rfc-reserva',
    titulo: 'Paso 14 — RFC (Perfil fiscal)',
    icono: null,
    descripcion: 'Selecciona el RFC con el que se emitirá la factura de la renta. Si tienes varios perfiles registrados (empresa o persona física) elige el correspondiente.',
    selector: '[data-tour="select-rfc"]',
    accion: null,
    posicion: 'right',
  },
  {
    id: 'desglose-precio-reserva',
    titulo: 'Paso 15 — Desglose de precio',
    icono: null,
    descripcion: 'En el panel derecho verás el desglose: subtotal + IVA (16%). Si eliges pago con Tarjeta se añade una comisión del 3.6%. Para rentas mensuales se muestra el monto diferido por mensualidad.',
    selector: '[data-tour="resumen-precio"]',
    accion: null,
    posicion: 'left',
  },
  {
    id: 'datos-banco-reserva',
    titulo: 'Paso 16 — Transferencia bancaria',
    icono: null,
    descripcion: 'Si eliges Transferencia, aquí verás la CLABE interbancaria, la referencia de pago y el banco beneficiario. Haz clic sobre cada dato para copiarlo al portapapeles.',
    selector: '[data-tour="datos-banco"]',
    accion: null,
    posicion: 'right',
  },
  {
    id: 'solicitar-reserva',
    titulo: 'Paso 17 — Solicitar Reservación',
    icono: null,
    descripcion: 'Si el almacén requiere aprobación del Host, aparecerá el botón "Solicitar Reservación". Al pulsarlo el Host recibirá una notificación y revisará tu solicitud antes de confirmarla.',
    selector: '[data-tour="btn-solicitar"]',
    accion: null,
    posicion: 'top',
  },
  {
    id: 'progreso-reserva',
    titulo: 'Paso 18 — Seguimiento',
    icono: null,
    descripcion: 'Podrás seguir el avance de tu reserva: Confirmar Datos → Esperar Aprobación → Completar Pago → Reserva Completa. Para reservas inmediatas el flujo va directamente a Completar Pago.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
  {
    id: 'listo-reserva',
    titulo: '¡Reserva en camino!',
    icono: 'check',
    descripcion: '¡Ya sabes cómo reservar un almacén en PalletCloud! Una vez aprobada y pagada la reserva recibirás la dirección exacta del almacén y todos los detalles de acceso.',
    selector: null,
    accion: null,
    posicion: 'center',
  },
];

export const TourProvider = ({ children }) => {
  const [tourActivo, setTourActivo] = useState(false);
  const [pasoActual, setPasoActual] = useState(0);
  const [pasos, setPasos] = useState(pasosRegistro);
  const accionesRef = useRef({});

  const registrarAccion = useCallback((nombre, fn) => {
    accionesRef.current[nombre] = fn;
  }, []);

  const ejecutarAccion = useCallback((accion) => {
    if (accion && accionesRef.current[accion]) {
      accionesRef.current[accion]();
    }
  }, []);

  const iniciarTour = useCallback((nuevoPasos = null) => {
    if (nuevoPasos) setPasos(nuevoPasos);
    else setPasos(pasosRegistro);
    setPasoActual(0);
    setTourActivo(true);
  }, []);

  const siguientePaso = useCallback(() => {
    setPasoActual(prev => {
      const siguiente = prev + 1;
      if (siguiente < pasos.length) {
        const paso = pasos[siguiente];
        if (paso.accion) {
          // Pequeño delay para que la UI reaccione antes de buscar el elemento
          setTimeout(() => ejecutarAccion(paso.accion), 100);
        }
        return siguiente;
      }
      return prev;
    });
  }, [pasos, ejecutarAccion]);

  const anteriorPaso = useCallback(() => {
    setPasoActual(prev => (prev > 0 ? prev - 1 : 0));
  }, []);

  const terminarTour = useCallback(() => {
    setTourActivo(false);
    setPasoActual(0);
    localStorage.setItem(TOUR_REGISTRO_KEY, 'true');
  }, []);

  const resetearTour = useCallback(() => {
    localStorage.removeItem(TOUR_REGISTRO_KEY);
  }, []);

  const yaVio = () => !!localStorage.getItem(TOUR_REGISTRO_KEY);

  return (
    <TourContext.Provider value={{
      tourActivo,
      pasoActual,
      pasos,
      iniciarTour,
      siguientePaso,
      anteriorPaso,
      terminarTour,
      resetearTour,
      registrarAccion,
      yaVio,
    }}>
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => {
  const ctx = useContext(TourContext);
  if (!ctx) throw new Error('useTour debe usarse dentro de TourProvider');
  return ctx;
};
